module.exports = __webpack_public_path__ + "static/metaltraining1-c3345089a5b4fc59a2c62bf2c2d81ae2.png";